// 英文版
export default {
  home: 'Home',
  aboutUs: 'About Us',
  productsAndServices: 'Products & Services',
  projectCases: 'Project Cases',
  contactUs: '📩 Contact Us',
  contactUs2: 'Contact Us',
  scrollDown: 'Scroll Down',
  companyName: 'Ocean Harmony Trade Co., Ltd',
  companyIntro: 'Company Introduction',
  brandStory: 'Brand Story',
  developmentHistory: 'Development History',
  corporateCulture: 'Corporate Culture',
  qualificationsAndHonors: 'Qualifications & Honors',
  partners: 'Partners',
  customer: 'Customer',
  domesticNetwork: 'Domestic Network',
  overseasNetwork: 'Overseas Network',
  businessOutlets: 'Business Outlets',
  fullCategoryTransportService: 'Full-Category Transport Service',
  oneStopSupplyChainService: '＂One-Stop＂ Supply Chain Service',
  mainEngineeringMaterialsProducts: 'Main Engineering Materials Products',
  logisticsBusiness: 'Logistics Business',
  materialsBusiness: 'Materials Business',
  fullSupplyChainBusiness: 'FullSupplyChain Business',
  aboutOceanHarmony: 'About Ocean Harmony',
  historyAndEvolution: 'History & Evolution (2024 ~ Present)',
  companyHonors: 'Company Honors',
  address: 'Address',
  phone: 'Phone',
  email: 'Email',
  send: 'Send',
  weChatQRCode: 'WeChat QR Code',
  scanToFollowUs: 'Scan to Follow Us',
  contact: 'Feel free to send your inquiry!',
  mondayToFriday: 'Sunday to Thursday',
  leaveMessage: 'Message',
  subject: 'Company name',
  nickname: 'How should we address you',
  cooperationIntent: 'Cooperation interest',
  companyTopName: "Zhongcheng Group",
  transportation: "Zhongcheng Transport",
  copyright: "All rights reserved",
  companyTopTitle: "ZCTS SHENZHEN CO., LTD.",
  projectDetail: 'Project Detail',

  enterYourName: 'e.g. Manager Wang / Mr. Zhang',
  nameRequired: 'Please enter how we should address you',
  enterYourPhone: 'Please enter your mobile number or the WeChat-linked mobile number so our specialist can reach you quickly',
  phoneRequired: 'Please enter your mobile number',
  invalidPhone: 'Please enter a valid mobile number',
  enterYourEmail: 'Optional. Helpful if you want to receive a quotation',
  enterSubject: 'Please enter the full or short company name (enter "Individual" for personal business)',
  companyRequired: 'Please enter the company name',
  selectIntent: 'Please select the service you need',
  intentLogistics: 'I have cargo that needs transport / customs clearance / warehousing (logistics)',
  intentTrade: 'I want to purchase goods or need import-export agency (trade and supply chain)',
  intentSupplier: 'I am a manufacturer or service provider and want to offer supply or capacity (supplier cooperation)',
  intentOther: 'Other business inquiry (not sure yet)',
  leaveHintDefault: 'Please select your cooperation interest first',
  leaveHintLogistics: 'Please briefly describe the cargo name, origin and destination (e.g. Guangzhou to Hong Kong), and estimated weight or volume.',
  leaveHintTrade: 'Please briefly describe the products you want to purchase, or the cargo, target region, and whether you need import-export, tax rebate, or financing support.',
  leaveHintSupplier: 'Please briefly describe your main products or advantageous logistics routes and cooperation ideas. We will forward them to the relevant team.',
  leaveHintOther: 'Please briefly describe your business background and cooperation needs. Our specialist will arrange the right department.',
  enterMessageContent: 'Please enter your message',
  enterValidEmail: 'Please enter a valid email address',
  messageContentAtLeast10: 'Message content must be at least 10 characters',
  nameLengthBetween2And30: 'Name length must be between 2 and 30 characters',
  formSubmitSuccess: 'Submission successful! Thank you for your message.',
  completeFormBeforeSubmitting: 'Please complete the form before submitting',
  submitFailed: 'Submission failed. Please try again later.',
  slideVerifyLabel: 'Security check',
  verifyDialogTitle: 'Security verification',
  verifyDialogDesc: 'Please drag the slider to the end to confirm you are not a bot.',
  cancel: 'Cancel',
  slideVerifyText: 'Drag the slider to the right',
  verificationSuccess: 'Verified',
  completeSlideVerifyFirst: 'Please complete the slide verification first',
  subjectLengthLimit: 'Company name must be 2 to 100 characters',
  messageContentLengthLimit: 'Message must be between 10 and 500 characters',
  mainTilte: 'Deeply cultivate the field of engineering projects, supplying the following main materials products based on the characteristics of engineering projects',
  ViewDetails: 'View Details',
  Loading: 'Loading...',
  companyCoverage: "Domestic <span class=\"map-top\">&nbsp;13&nbsp;</span> companies cover major port cities along the national route",
  businessOutletsTitle1: "Ocean Harmony has currently established <span class='w-map-top'> &nbsp;9&nbsp; </span> directly managed overseas outlets",
  businessOutletsTitle2: "Over <span class='w-map-top'> &nbsp;14&nbsp; </span> years of deep presence in Africa and Southeast Asia",
  qayimatAlmuntajat: "Qayimat Almuntajat",
  LanguageMessage: "Language changed successfully!",
  WHATSAPP: 'WHATSAPP'
};